<template>
  <section class="app-main">
    <div class="app-content">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
}
</script>

<style scoped>
.app-main {
  min-height: calc(100vh - 70px);
  padding: 24px 28px 36px;
  background: #f4f7f3;
}

.app-content {
  min-height: calc(100vh - 130px);
}

@media (max-width: 720px) {
  .app-main {
    min-height: calc(100vh - 64px);
    padding: 16px 14px 28px;
  }

  .app-content {
    min-height: calc(100vh - 108px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue